export const DEFAULT_GLOBAL_COMPONENT_SPACING = 32
export const DEFAULT_GLOBAL_COMPONENT_SPACING_INTERVAL = 4

// Common constants for typography
export const CANVAS_TYPOGRAPHY_CSS_PROPERTIES = [
  'font-family',
  'font-size',
  'font-weight',
  'line-height',
  'letter-spacing',
  'text-transform',
  'color',
] as const

export const CANVAS_TYPOGRAPHY_PRESETS = ['h_1', 'h_2', 'h_3', 'big_text', 'normal_text', 'small_text'] as const

// Paper size presets for PDF dimensions
export const PAPER_SIZE_PRESETS = {
  A4: { width: '210mm', height: '297mm' },
  A3: { width: '297mm', height: '420mm' },
  A5: { width: '148mm', height: '210mm' },
  B3: { width: '353mm', height: '500mm' },
  B4: { width: '250mm', height: '353mm' },
  B5: { width: '176mm', height: '250mm' },
  'US Legal': { width: '8.5in', height: '14in' },
  'US Letter': { width: '8.5in', height: '11in' },
} as const
